"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Aug 03 2018
 */

var FormDefinitionConverter_1 = require("./conversions/FormDefinitionConverter");

var FormDefinitionConverterImpl_1 = require("./conversions/FormDefinitionConverterImpl");

var FormFieldConverter_1 = require("./conversions/FormFieldConverter");

var FormFieldConverterImpl_1 = require("./conversions/FormFieldConverterImpl");

var AppModule_1 = require("../../modules/AppModule");

var typescript_ioc_1 = require("@logio/typescript-ioc");
/**
 * Configures form definition module.
 * @author Radek Beran
 */


var FormDefinitionAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(FormDefinitionAppModule, _AppModule_1$AppModul);

  function FormDefinitionAppModule() {
    var _this;

    _classCallCheck(this, FormDefinitionAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FormDefinitionAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'formDefinition';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(FormDefinitionAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(FormFieldConverter_1.FormFieldConverter).to(FormFieldConverterImpl_1.FormFieldConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(FormDefinitionConverter_1.FormDefinitionConverter).to(FormDefinitionConverterImpl_1.FormDefinitionConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return FormDefinitionAppModule;
}(AppModule_1.AppModule);

exports.FormDefinitionAppModule = FormDefinitionAppModule;